import { SeoPage } from 'libs/shared-lib/interfaces';

export const PROMOTION_NOT_AVAILABLE_SEO_FR: SeoPage = {
    title: 'Action introuvable / Action non disponible',
    description: 'Cette action est introuvable.',
    image: '',
    twitter: {
        card: 'summary',
        title: 'Action introuvable / Action non disponible',
        description: 'Cette action est introuvable.',
    },
    og: {
        title: 'Action introuvable / Action non disponible',
        description: 'Cette action est introuvable.',
    },
    robots: {
        noIndex: true,
        noFollow: true,
    },
};
